import { render, staticRenderFns } from "./PartnerBoxTypeItem.vue?vue&type=template&id=196341b1&scoped=true&"
import script from "./PartnerBoxTypeItem.vue?vue&type=script&lang=js&"
export * from "./PartnerBoxTypeItem.vue?vue&type=script&lang=js&"
import style0 from "./PartnerBoxTypeItem.vue?vue&type=style&index=0&id=196341b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196341b1",
  null
  
)

export default component.exports